import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import FAVORITE_POSTS_QUERY from '../graphql/favoritePosts';
import POST_SUMMARY_FIELDS_FRAGMENT from '../graphql/fragments/PostSummaryFields';
import type {
  FavoritePostsQuery,
  FavoritePostsQueryVariables,
} from '../graphql/generated/graphqlTypes';
import updateSubscribedList from '../utils/graphql/updateSubscribedList';

const POST_FAVORITE_ADDED_SUBSCRIPTION = gql`
  subscription postFavoriteAdded {
    post: postFavoriteAdded {
      ...PostSummaryFields
    }
  }
  ${POST_SUMMARY_FIELDS_FRAGMENT}
`;

const POST_FAVORITE_REMOVED_SUBSCRIPTION = gql`
  subscription postFavoriteRemoved {
    post: postFavoriteRemoved {
      ...PostSummaryFields
    }
  }
  ${POST_SUMMARY_FIELDS_FRAGMENT}
`;

export default function useFavoritePosts() {
  const { data, subscribeToMore } = useQuery<
    FavoritePostsQuery,
    FavoritePostsQueryVariables
  >(FAVORITE_POSTS_QUERY);

  useEffect(() => {
    const unsubscribes = [
      POST_FAVORITE_ADDED_SUBSCRIPTION,
      POST_FAVORITE_REMOVED_SUBSCRIPTION,
    ].map((query) =>
      subscribeToMore({
        document: query,
        updateQuery: updateSubscribedList(
          'currentSession.user.favoritePosts',
          'post',
          query === POST_FAVORITE_ADDED_SUBSCRIPTION,
        ),
      }),
    );

    return () => {
      unsubscribes.forEach((unsubscribe) => {
        unsubscribe();
      });
    };
  }, [subscribeToMore]);

  return data?.currentSession?.user?.favoritePosts ?? [];
}
